import { useMutation } from '@apollo/client';
import { ACCOUNT_GET_BUYER_APPLICATIONS } from '@application/api';
import { useRouter, useShowToast } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  MtApplicationsBuyerCancelApplicationMutation,
  MtApplicationsBuyerCancelApplicationMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';

export const MT_APPLICATIONS_BUYER_CANCEL_APPLICATION = graphql(`
  mutation MtApplicationsBuyerCancelApplication($applicationId: Int!) {
    cancelApplication(applicationId: $applicationId) {
      id
      status
    }
  }
`);

export const useCancelApplication = () => {
  const { translate } = useRouter();
  const { showToast } = useShowToast();

  const [accept, { loading }] = useMutation<
    MtApplicationsBuyerCancelApplicationMutation,
    MtApplicationsBuyerCancelApplicationMutationVariables
  >(MT_APPLICATIONS_BUYER_CANCEL_APPLICATION, {
    awaitRefetchQueries: true,
    refetchQueries: [ACCOUNT_GET_BUYER_APPLICATIONS],
  });

  const cancelApplication = useCallback(
    async (applicationId: number) => {
      await accept({
        variables: { applicationId },
      });
      showToast(translate('common.toasts.canceled'), { type: 'success' });
    },
    [accept, showToast, translate],
  );

  return {
    cancelApplication,
    cancelApplicationIsLoading: loading,
  };
};
